<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <span slot="titleLeft">
        <span style="margin-left: 16px" class="error"
          >如果有其他费用，请通过车辆费用申请去报销</span
        >
      </span>
      <Oil ref="oil" @getBindCard="getBindCard" />
      <IsFullOil ref="isFullOil" />
      <Bridge ref="bridge" />
      <!-- <Other ref="other" /> -->
      <!-- <Meter ref="meter" /> -->
      <!-- <Report ref="report" /> -->
    </qx-card>
    <!-- <SubBtnBox @sub="sub" /> -->
    <SubBtnBox :customContent="true">
      <section slot="customContent">
        <el-button class="btn" @click="cancel">取消</el-button>
        <el-button class="btn" type="info" @click="saveOrSubmit('save')"
          >保存</el-button
        >
        <el-button class="btn" type="primary" @click="saveOrSubmit('submit')"
          >提交</el-button
        >
      </section>
    </SubBtnBox>
  </div>
</template>

<script>
import Oil from './oil/oil';
import Bridge from './bridge/bridge';
// import Other from './other/other';
// import Meter from './meter';
// import Report from './report';
import IsFullOil from './isFullOil';
import SubBtnBox from 'components/subBtnBox';
import {
  orderRepostCostEdit,
  orderRepostCostDetail,
  orderRepostCostQueryCard,
} from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    Oil,
    Bridge,
    // Other,
    // Meter,
    // Report,
    IsFullOil,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/operate/order/deal/reportCost',
      formComponents: ['oil', 'bridge', 'isFullOil',
        // 'other', 'meter'
      ],
      editParams: {
        orderId: this.$route.query.id,
        operation: 'submit',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        orderId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: orderRepostCostDetail,
    editApi: orderRepostCostEdit,
    async getBindCard () {
      const res = await orderRepostCostQueryCard({
        orderId: this.$route.query.id,
      });
      if (this.$refs.oil) {
        const _this = this.$refs.oil;
        _this.cardNoSelectOptions = [
          {
            label: '其他',
            value: 0,
          },
        ];
        if (res.oilCardNum && res.oilCardNum.length) {
          const resCardNoSelectOptions = res.oilCardNum.map((cardNo) => ({
            label: cardNo,
            value: cardNo,
          })) || [];
          _this.cardNoSelectOptions.unshift(...resCardNoSelectOptions);
          for (let i = 0; i < _this.$refs.formBox.length; i++) {
            const formBox = _this.$refs.formBox[i];
            formBox.baseForm.cardNoSelectOptions = _this.cardNoSelectOptions;
            formBox.$refs.baseForm.setVal('cardNoSelect', formBox.baseForm.cardNoSelectOptions[0].value);
          }
        } else {
          for (let i = 0; i < _this.$refs.formBox.length; i++) {
            const formBox = _this.$refs.formBox[i];
            formBox.baseForm.cardNoSelectOptions = _this.cardNoSelectOptions;
          }
        }
        _this.setFormState();
      }
      if (this.$refs.bridge) {
        const _this = this.$refs.bridge;
        if (res.etcCardNum) {
          _this.etcCardNum = res.etcCardNum;
          for (let i = 0; i < _this.$refs.formBox.length; i++) {
            const formBox = _this.$refs.formBox[i];
            formBox.$refs.baseForm.setVal('cardNo', _this.etcCardNum);
          }
        }
        _this.setFormState();
      }
    },
    cancel () {
      this.close();
    },
    // 保存/提交
    async saveOrSubmit (operation) {
      this.editParams.operation = operation;
      if (operation === 'submit') {
        const confirmRes = await this.$confirm('提交之后数据不允许修改，请确认！', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch(() => {
          // 取消
        });
        if (confirmRes === 'confirm') {
          this.sub();
        }
      } else {
        this.sub();
      }
    },
  },
  async mounted () {
    if (this.$route.path !== this.pageUrl) {
      return;
    }
    // await this.$refs.oil.getList();
    // await this.$refs.other.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
